'use es6';

import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import styled from 'styled-components';
import { getName, getId as getReportId } from 'reporting-action-components/data/schemas/reportSchema';
import { getEventValue } from 'reporting-action-components/utils/jsEventUtils';
import useExportReportProblem from 'reporting-action-components/reportingActions/exportReport/useExportReportProblem';
import { isUnsupportedDataExportType as getUnsupportedDataExportType } from 'reporting-action-components/reportingActions/shared/emailLogic';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledListItemContainer = styled.div.withConfig({
  displayName: "SelectedWidgetCheckbox__StyledListItemContainer",
  componentId: "sc-3nphk8-0"
})(["display:flex;align-items:end;"]);
const SelectedWidgetCheckbox = ({
  report,
  exportType,
  handleReportsSelectionChange,
  selectedReports
}) => {
  const reportId = getReportId(report);
  const isUnsupportedDataExportType = getUnsupportedDataExportType(exportType);
  const exportProblem = useExportReportProblem({
    report,
    hasLimitedReportTypeSupport: true
  });
  const isUnsupportedReport = isUnsupportedDataExportType && exportProblem.problem;
  useEffect(() => {
    const selectedReport = selectedReports.has(reportId.toString());
    if (isUnsupportedReport && selectedReport) {
      handleReportsSelectionChange(reportId.toString());
    }
  }, [handleReportsSelectionChange, isUnsupportedReport, reportId, selectedReports]);
  return /*#__PURE__*/_jsxs(StyledListItemContainer, {
    children: [/*#__PURE__*/_jsx(UICheckbox, {
      name: "reportsSelection",
      checked: selectedReports.has(reportId.toString()),
      value: reportId,
      disabled: isUnsupportedReport,
      onChange: e => {
        const selectedReport = getEventValue(e);
        handleReportsSelectionChange(selectedReport);
      },
      children: getName(report) || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email.dashboard.prompt.unnamed"
      })
    }), isUnsupportedReport && /*#__PURE__*/_jsx(UIHelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email.dashboard.unsupportedDataExportTooltip"
      }),
      className: "p-left-2"
    })]
  });
};
export default SelectedWidgetCheckbox;